// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3fBu9","bigColWidth":"Table_bigColWidth__3S5mk","biggerColWidth":"Table_biggerColWidth__2HkfO","row":"Table_row__w2eQs","col":"Table_col__1hPKA"};